import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Button } from '@nintex-ux/react-core/dist/Button/Button';
import { Notification } from '@nintex-ux/react-core/dist/Notification';
import { Badge } from '@nintex-ux/react-core/dist/Badge/Badge';
import Modal, {
    ModalBody,
    ModalHeader,
    ModalFooter,
} from '@nintex-ux/react-core/dist/Modal';
import { SvgIcon } from '@nintex-ux/react-core/dist/SvgIcon/SvgIcon';
import '@nintex-ux/icons-svg-monochrome/icons/utility/close.svg';
import '@nintex-ux/icons-svg-monochrome/icons/utility/error-alt.svg';
import '@nintex-ux/icons-svg-monochrome/icons/utility/information-alt.svg';
import '@nintex-ux/icons-svg-monochrome/icons/utility/open-in-a-new-window.svg';

import integrationImage from '../assets/SharePoint_Nintex.png';
import nwcMainImage from '../assets/NWC_Main.png';
import o365Image from '../assets/O365_1.png';
import nwcImage from '../assets/NWC_1.png';
import '../custom.scss';
import cn from 'classnames';
import { useHistory } from 'react-router-dom';
import qs from 'query-string';
import Alert from '@nintex-ux/react-core/dist/Alert/Alert';


const OnBoardToNwc = () => {
    const { t } = useTranslation();

    const [errorMessage, setErrorMessage] = useState();
    const [isProcessing, setProcessing] = useState(false);
    const [spoRedirectUri, setSpoRedirectUri] = useState('');
    const [nwcRedirectUri, setNwcRedirectUri] = useState('');
    const [spoToken, setSpoToken] = useState('');
    const history = useHistory();
    const queryString = qs.parse(history.location.search);
    const [showInformationModal, setShowInformationModal] = useState(true);

    useEffect(() => {
        const getRedirectInfo = async () => {
            setErrorMessage('');
            setProcessing(true);

            try {
                const getRedirectInfoUrl = `/GetRedirectInfo/${queryString.spTenantId}/${queryString.uniqueId}`;
                const response = await fetch(getRedirectInfoUrl);
                if (!response.ok) {
                    setErrorMessage(t('genericError'));
                    setProcessing(false);
                }
                const data = await response.json();
                setSpoRedirectUri(data.spoRedirectUri);
                setSpoToken(data.spoToken);
                setNwcRedirectUri(data.nwcRedirectUri);

            } catch (error) {
                setErrorMessage(t('genericError'));
                setProcessing(false);
            } finally {
                setProcessing(false);
            }
        };
        getRedirectInfo();
    }, []);

    const navigateToNintex = () => {
        window.open('https://www.nintex.com/process-automation/advanced-workflow/', '_blank');
    };

    const navigateToNwc = () => {
        if (nwcRedirectUri) {
            window.open(nwcRedirectUri, '_self');
            return;
        }

        setShowInformationModal(false);
    };

    const navigateToNintexO365 = () => {
        document.getElementById('formRedirectUserToO365').submit();
    };

    const navigateToNintexTrialPage = () => {
        window.open('https://www.nintex.com/trial/?utm_medium=referral&utm_source=O365-NWCTrial#NWC', '_blank');
    };

    const goBackToSp = (e) => {
        if (e) {
            e.preventDefault();
        }
        if (queryString.listUri) {
            window.open(queryString.listUri, '_self');
        } else {
            window.open(queryString.spSiteUri, '_self');
        }
    };

    const isIntegrationEnabled = () => {
          return (queryString.nwc);
    }

    const isNewTenant = () => {
        return (queryString.newTenant);
    }
    const noTenantButOtherConnectionsFound = () => {
        return (queryString.noTenantButOtherConnectionsFound);
    }

    const goBackToInformationPage = () => {
        setShowInformationModal(true);
    }

    const renderNewAppBanner = () => {
        return (
            <Notification type="info">
                <SvgIcon icon="information-alt" />
                <span>
                    {t('onBoardToNwc.upgradeNotice')} <a href="https://appsource.microsoft.com/en-us/product/office/WA200004625?tab=Overview" target="_blank" rel="noopener noreferrer">SharePoint Store</a>
                    <SvgIcon icon="open-in-a-new-window" withWrapper />.
                </span>
            </Notification>
        );
    }

    const renderInformation = () => (
        <Modal className={cn('ntx-modal-dialog-information')} open={showInformationModal}>
            <ModalHeader className={cn('ntx-modal-dialog-header')} onClose={(e) => goBackToSp(e)}>
               {t('onBoardToNwc.title')} 
            </ModalHeader>
            
            <ModalBody>
                <div className="ntx-modal-onboard-info-body">
                    {errorMessage && (
                        <Alert type="danger" data-test-id="nx-splashpage-error">
                            <p>{errorMessage}</p>
                        </Alert>
                    )}
                    {renderNewAppBanner()}
                    <form id="formRedirectUserToO365" method="post" action={spoRedirectUri}>
                        <input type="hidden" name="spAppToken" value={spoToken} />
                    </form>
                        < >
                        {!isIntegrationEnabled() && (<div className="ntx-modal-body-row">
                                <div className="ntx-modal-body-column">
                                <h2 className="nx-splashpage-headertext">{t('nintexAutomationCloud')}</h2>
                                <p>{t('onBoardToNwc.sectionDescription')}<br/>
                                    <Button
                                        type="link"
                                        data-test-id="nintexBtn1"
                                        className={cn('ntx-button-link')}
                                        onClick={() => navigateToNintex()}>
                                            www.nintex.com.
                                    </Button>
                                </p>
                                <div>
                                    <Button className="ntx-splash-nwcBtn1" data-test-id="btnNwc1" type="primary" processing={ isProcessing} disabled={isProcessing || !!errorMessage} onClick={() => navigateToNwc()}>
                                        {t('onBoardToNwc.useNac')}
                                    </Button>
                                </div>
                            </div>

                            <div className="ntx-modal-body-column">
                                <img className="ntx-splashpage-image" data-test-id="mainImage" src={nwcMainImage} alt={t('onBoardToNwc.imageAltText')} />
                            </div>
                        </div>)}

                        {isIntegrationEnabled() && (<div className="ntx-modal-body-row ntx-modal-body-row-navigate-options">
                            <div className="ntx-modal-body-column-border first-block">
                                <div>
                                    <h2 className="nx-splashpage-headertext">{t('onBoardToNwc.workflowO365')}</h2>
                                    <p className="ntx-modal-navigation-content">{t('onBoardToNwc.useWorkflowO365')}</p>
                                </div>
                                <div>
                                    <div className="ntx-splash-image">
                                        <img className="ntx-splashpage-image" data-test-id="o365Image" src={o365Image} alt={t('onBoardToNwc.gotoWorkflowO365ImageAltText')} />
                                    </div>
                                    <div className="ntx-btn-navigate">
                                        
                                        <Button data-test-id="btnO365" type="secondary" processing={isProcessing} disabled={isProcessing || !!errorMessage} onClick={(e) => navigateToNintexO365(e)}>
                                            {t('onBoardToNwc.openWorkflowO365')}
                                        </Button>

                                    </div>
                                </div>
                            </div>
                            <div className="ntx-modal-body-column-border second-block">
                                <div>
                                    <h2 className="nx-splashpage-headertext">
                                        <span>{t('nintexAutomationCloud')}</span>
                                        <Badge type="primary" size="small">{t('onBoardToNwc.updateAvailable')}</Badge>
                                    </h2>
                                    <p className="ntx-modal-navigation-content">{t('onBoardToNwc.nacDescription')}</p>
                                </div>
                                <div>
                                    <div className= "ntx-splash-image">
                                        <img className="ntx-splashpage-image" data-test-id="nwcImage" src={nwcImage} alt={t('onBoardToNwc.gotoNacImageAltText')} />
                                    </div>
                                    <div className="ntx-btn-navigate">
                                        <Button type="primary" data-test-id="btnNwc2" processing={isProcessing} disabled={isProcessing || !!errorMessage} onClick={() => navigateToNwc()}>
                                            {t('onBoardToNwc.openNac')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                    </>
                </div>
            </ModalBody>
            <>
            {!isIntegrationEnabled() &&  (<ModalFooter>
                    {!isNewTenant() && spoToken && (<Button processing={isProcessing}
                        disabled={isProcessing || !!errorMessage}
                        data-test-id="LinkBtnO365"
                        type="link"
                        onClick={() => navigateToNintexO365()}>
                        {t('onBoardToNwc.useWorkflowO365Classic')}
                    </Button>)}
              
            </ModalFooter>)}</>
        </Modal>
    );


    const renderTrialInformation = () => ( <Modal className={cn('ntx-modal-dialog-information')} open>
        <ModalHeader className={cn('ntx-modal-dialog-header')} onClose={(e) => goBackToSp(e)}>
            {!isNewTenant() ? t('onBoardToNwc.integration.integrationRequired') : t('onBoardToNwc.integration.setupNacIntegration') }
            </ModalHeader>

        <ModalBody>
            <div className="ntx-modal-onboard-info-body">

                {renderNewAppBanner()}
                <img className="ntx-integration-image" data-test-id="ntx-integration-image" src={integrationImage} alt={t('onBoardToNwc.imageAltText')} />

                {isNewTenant() && (<div tabIndex="1" data-test-id="newTenant">
                    <Trans i18nKey="onBoardToNwc.integration.newTenantDescription" />
                    
                    <Button
                        data-test-id="trialPageLink"
                        type="link"
                        className={cn('ntx-trialbutton-link')}
                        onClick={() => navigateToNintexTrialPage()}>
                        {t('onBoardToNwc.integration.signupFreeTrial')}
                    </Button>
                </div>)}

                {!isNewTenant() && noTenantButOtherConnectionsFound() && (<div data-test-id="notenantLinkFound">
                    <Trans i18nKey="onBoardToNwc.integration.integratedNoConnections" />
                </div>)}

                {!isNewTenant() && !noTenantButOtherConnectionsFound() && (<div tabIndex="1" data-test-id="noIntegrationsFound">
                    <Trans i18nKey="onBoardToNwc.integration.noIntegration" />

                    <Button
                        data-test-id="trialPageLink"
                        type="link"
                        className={cn('ntx-trialbutton-link')}
                        onClick={() => navigateToNintexTrialPage()}>
                        {t('onBoardToNwc.integration.clickToSignupTenant')}
                    </Button>
                </div>)}
                            
            </div>
        </ModalBody>

        <ModalFooter>
        
            {!queryString.newTenant && <Button type="secondary" className={cn('ntx-btn-back')} onClick={() => goBackToInformationPage()}>
               {t('onBoardToNwc.back')} 
            </Button>}
            <Button type="primary" className={cn('ntx-btn-done')} onClick={(e) => goBackToSp(e)}>
                {t('onBoardToNwc.done')}
            </Button>
        </ModalFooter>
    </Modal>
    );

    return (
        <div>
            {!isNewTenant() && showInformationModal && renderInformation()}

            {!isNewTenant() && !showInformationModal && renderTrialInformation()}

            {isNewTenant() && renderTrialInformation()}

        </div>
    );
};

export default OnBoardToNwc;
